import { Box, Typography } from "@mui/material";

import {
  ProductUpdate,
  ProductUpdatePcm,
} from "api/memberPortal/product/productUpdate/productUpdate.types";

import ProductUpdateDisplay from "./ProductUpdateDisplay";

interface ProductUpdatePreviewProps {
  selectedUpdate?: ProductUpdate | ProductUpdatePcm;
}

const ProductUpdatePreview = ({
  selectedUpdate,
}: ProductUpdatePreviewProps) => {
  if (!selectedUpdate) {
    return (
      <Box
        display="flex"
        flex={1}
        alignItems="center"
        justifyContent="center"
        height="100%"
      >
        <Typography align="center" fontStyle="italic" display="block">
          No Updates to Preview
        </Typography>
      </Box>
    );
  }

  return (
    <ProductUpdateDisplay
      title={selectedUpdate.title}
      content={selectedUpdate.content}
      severity={selectedUpdate.severity}
    />
  );
};
export default ProductUpdatePreview;
